import React, { useState, useEffect, useContext, createContext } from 'react';

import { setLocalStorage, getLocalStorage, setLanguage } from '@common/Util';
import Notification from '@components/Notifications/Notification';
import tokenUtil from '@services/tokenUtil';

const GlobalContext = createContext();

export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useGlobalContext must be used within a GlobalContextProvider');
  }
  return context;
};

const GlobalContextProvider = ({ children }) => {
  const authData = tokenUtil.getUser();

  const [contextData, setContextData] = useState({
    loggedIn: !!authData?.email,
    user: authData?.email ? authData.email : false,
    open: false,
    lang: setLanguage(),
    message: '',
    severity: '',
    colorMode: getLocalStorage('colorMode') || 'light',
    isCatalogVisible: true, // just for fraunhofer can be false or true
    isSeatsNumber: true
  });

  useEffect(() => {
    setLocalStorage('colorMode', contextData?.colorMode);
  }, [contextData?.colorMode]);

  // Helper for toggling color mode
  const toggleColorMode = () => {
    setContextData((prev) => ({
      ...prev,
      colorMode: prev.colorMode === 'light' ? 'dark' : 'light'
    }));
  };

  const toggleCatalogView = () => {
    setContextData((prev) => ({
      ...prev,
      view: prev.view === 'grid' ? 'list' : 'grid'
    }));
  };

  return (
    <GlobalContext.Provider
      value={[contextData, setContextData, toggleColorMode, toggleCatalogView]}
    >
      {children}
      <Notification
        message={contextData?.message}
        open={contextData?.open}
        severity={contextData?.severity}
      />
    </GlobalContext.Provider>
  );
};

export default GlobalContextProvider;
